import {ComponentData} from "../../engine/tools/EntityManager";
import {SoundInstance} from "../../engine/tools/AudioLoader";

export class PumpSound implements ComponentData {

    pumpInstance: SoundInstance
    releaseInstance: SoundInstance
    moveInstance: SoundInstance
    wasTouching: boolean = false

    constructor(options?: Partial<PumpSound>) {
        Object.assign(this, options)
    }
}

